import * as React from "react"

const Breadcrumbs = (props) => {
  let bredCrumbList = new String()
  props.list.map((item, index) => {
    bredCrumbList += `{
      "@type": "ListItem",
      "position": ${index + 1},
      "item": {
          "@id": "${item.url}",
          "name": "${item.name}"
        }
    }`
    if (index + 1 != props.list.length) {
      bredCrumbList += ","
    }
  })

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [${bredCrumbList}]
        }`,
      }}
    />
  )
}

export default Breadcrumbs
